export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 0_04.d34c9b87.jpg";